import React, { useState } from 'react';

const EventTile = ({ event }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  // Better description truncation with word boundaries
  const truncateDescription = (text, maxLength = 120) => {
    if (text.length <= maxLength) return text;
    
    const truncated = text.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');
    
    // If we find a space, cut there to avoid breaking words
    return lastSpaceIndex > maxLength * 0.8 
      ? truncated.substring(0, lastSpaceIndex) + '...'
      : truncated + '...';
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  const description = truncateDescription(event.description);

  // Fallback image or placeholder
  const defaultImage = "data:image/svg+xml,%3Csvg width='80' height='80' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='80' height='80' fill='%23667eea'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='0.3em' fill='white' font-family='Arial' font-size='12'%3EEvent%3C/text%3E%3C/svg%3E";

  return (
    <a 
      href={event.link} 
      className="tile-link" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label={`View details for ${event.title}`}
    >
      <article className="tile-card horizontal" role="article">
        <div className="image-container">
          {imageLoading && (
            <div className="image-placeholder">
              <div className="loading-spinner"></div>
            </div>
          )}
          <img 
            src={imageError ? defaultImage : event.imageUrl} 
            alt={event.title}
            className={`tile-image-small ${imageLoading ? 'loading' : ''}`}
            onLoad={handleImageLoad}
            onError={handleImageError}
            loading="lazy"
          />
        </div>
        
        <div className="tile-content">
          <h3 className="tile-title">{event.title}</h3>
          <p className="tile-description">{description}</p>
          
          {/* Optional: Add event metadata if available */}
          {(event.date || event.venue || event.price) && (
            <div className="tile-meta">
              {event.date && <span className="meta-item">📅 {event.date}</span>}
              {event.venue && <span className="meta-item">📍 {event.venue}</span>}
              {event.price && <span className="meta-item price">💰 {event.price}</span>}
            </div>
          )}
        </div>
        
        <div className="tile-arrow" aria-hidden="true">›</div>
      </article>
    </a>
  );
};

export default EventTile;